module.exports = __webpack_public_path__ + "img/19.a0885c1.svg";